
import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, NgForm, AbstractControl, NgModel } from '@angular/forms';

import { State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';

import { Subscription, Subject, Observable } from 'rxjs'
import {
  FineUploaderBasic, CoreOptions, ChunkingOptions, CorsOptions, RequestOptions,
  CoreEvents, OnComplete, ChunkData, ParamNamesOptions
} from 'fine-uploader/lib/core';

import { UserProfileService, UpdateStateService, RaService,RvrsService } from '../../../core';
import { AuditStdImport, ImportResults } from '../../rate-audit/ra-create/utilities/auditstd-import-model';
import { AuditStdEdit } from '../../rate-audit/ra-create/utilities/auditstd-edit-model';
import { RvrsCreateFromExistingComponent } from './rvrs-create-from-existing/rvrs-create-from-existing.component';
import { environment } from '../../../../environments/environment';
import { RvrsCreateFromFileComponent } from 'app/main/rvrs-audit/rvrs-create/rvrs-create-from-file/rvrs-create-from-file.component';
import { RvrsCreateManualComponent } from 'app/main/rvrs-audit/rvrs-create/rvrs-create-manual/rvrs-create-manual.component';
import { RvrsCreateStep2Component } from './rvrs-create-step2/rvrs-create-step2.component';
import { RvrsCreateStep3Component } from './rvrs-create-step3/rvrs-create-step3.component';
import { CreateFromStandardAudit } from '../../../core/models/CreateFromStandardAudit-model';
import { CreateReverseAudit } from '../../../core/models/CreateReverseAudit';

import { ConfirmDialogComponent } from '../../../common/component/confirm-dialog/confirm-dialog.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
selector: 'app-rvrs-create',
templateUrl: './rvrs-create.component.html',
styleUrls: ['./rvrs-create.component.scss']
})
export class RvrsCreateComponent implements OnInit {

  @ViewChild('apprvrscreatefromexisting', { static: false }) createFromExisting:RvrsCreateFromExistingComponent;
  @ViewChild('apprvrscreatefromfile', { static: false }) createFromFile:RvrsCreateFromFileComponent;
  @ViewChild('apprvrscreatemanual', { static: false }) createManually:RvrsCreateManualComponent;
  @ViewChild(RvrsCreateStep2Component, { static: true }) createStep2:RvrsCreateStep2Component;
  @ViewChild(RvrsCreateStep3Component, { static: true }) createStep3:RvrsCreateStep3Component;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog:ConfirmDialogComponent;

  public step1View:string;
  public step1:{valid:boolean} = {valid:false};
  public step3:{valid:boolean} = {valid:false};

  @ViewChild('userForm', { static: false }) userForm: NgForm;

  importedData:CreateFromStandardAudit=new CreateFromStandardAudit();
  dataToSave:CreateReverseAudit=new CreateReverseAudit();
  selectedAuditID: string;

  showSpinner: boolean = false;
  okayToExit:boolean = true;
  showModal:boolean = false;
  typeOfAudit:string='';


  constructor(private raService: RaService,
    private updateStateService: UpdateStateService<boolean>,
    private rvrsService:RvrsService,
    private router:Router
    ,private route: ActivatedRoute,
    private userProfileService:UserProfileService
  ) {
    let url = window.location.href;
    //get the correct view for step 1 based on the URL
    let urlFolderName = url.replace(/^.*main\/reverseaudit\/(\w*)(\/.*$|\?.*$|$)/i, '$1')
    if(urlFolderName) {
      this.step1View = urlFolderName;
    } else {
      console.error('Problem with url:' + url);
      this.step1View = 'unknown';
    }
  }

  ngOnInit() {
    let current =  this.router.routerState.snapshot.url;
    let crrnt = this.route.snapshot.url;
    if(current.endsWith('manuallyBuildRateAudit')) {
      this.typeOfAudit='manuallyBuildRateAudit';
    }else if(current.endsWith('createFromRateAudit')) {
      this.typeOfAudit='createFromRateAudit';
    }else if(current.endsWith('importFromRateAuditFile')) {
      this.typeOfAudit='importFromRateAuditFile';
    }
    this.dataToSave.AuditContactEmailAddress = this.userProfileService.data.Email;

  }

  onStepChanged(event) {
  }

  rateAuditChosen(event:{inputValid:boolean, selectedAuditID:string}){
    this.step1.valid = event.inputValid;
    this.okayToExit = !this.step1.valid;
    this.selectedAuditID = event.selectedAuditID;
  }

  dataManuallyEntered(event:{inputValid:boolean, selectedAuditID:string}) {
    this.step1.valid =true;
    this.selectedAuditID = null;
  }

  onStep1Next(event) {
    if(this.typeOfAudit=="manuallyBuildRateAudit"){
      let manualdata= this.createManually.GetManualData();
      if(manualdata){
        this.showSpinner = true;
        event.okToProceed=true;
        var newAuditData:any={};
        newAuditData.AmadeusRAC=manualdata.AmadeusRAC;
        newAuditData.ApolloRAC=manualdata.ApolloRAC;
        newAuditData.GalileoRAC=manualdata.GalileoRAC;
        newAuditData.SabreRAC=manualdata.SabreRAC;
        newAuditData.WorldspanRAC=manualdata.WorldspanRAC;

        newAuditData.AuditAmadeus=manualdata.auditAmadeus;
        newAuditData.AuditApollo=manualdata.auditApollo;
        newAuditData.AuditGalileo=manualdata.auditGalileo;
        newAuditData.AuditSabre=manualdata.auditSabre;
        newAuditData.AuditWorldspan=manualdata.auditWorldspan;
        newAuditData.SabrePCC=manualdata.sabrePCC;

        newAuditData.AuditID=manualdata.AuditID;
        newAuditData.CustomerAccountID=manualdata.CustomerAccountID;
        newAuditData.AuditProperty=manualdata.property;
        newAuditData.ChainCodes=manualdata.ChainCodes;
        newAuditData.CustomerID=manualdata.CustomerID;
        newAuditData.CustomerAccountName=manualdata.CustomerAccountName;
        newAuditData.MaxSearchRadius=manualdata.MaxSearchRadius;
        newAuditData.notificationTemplates=manualdata.NotificationTemplates;
        newAuditData.RvrAuditPoints=manualdata.RvrAuditPoints;
        newAuditData.RACFilters=manualdata.RACFilters;
        newAuditData.ContractYear=manualdata.ContractYear;
        this.rvrsService.CreateRateAuditInReverseAudit( newAuditData).pipe( finalize(() => {
          this.showSpinner = false;
        }))
        .subscribe(data=>{
          var AuditID=data;
          this.getRateAuditData(AuditID);
        });
      }
      else{
        event.okToProceed=false;
      }

    }
    else if(this.typeOfAudit=="createFromRateAudit"){
      this.getRateAuditData(this.selectedAuditID);
  }
    else if(this.typeOfAudit=="importFromRateAuditFile"){
      this.getRateAuditData(this.selectedAuditID);
    }
  }

  onStep2Next(event){
    this.createStep2.UpdateIncludeExcludeChainCodes();
  }

  onComplete(event){
    event.okToProceed = false;
    if(this.createStep3.Validated()){
      this.showSpinner = true;
      this.rvrsService.save(this.dataToSave).pipe(
        finalize(()=> this.showSpinner = false))
        .subscribe( (rslt) => {
            this.confirmDialog.confirm("Created Audit successfully." , "","Audit Created Successfully")
              .subscribe(() =>{
                this.okayToExit = true;
                this.router.navigate(['/main/reverseAudit/monitor'])
              });
        },
        (err)=>{
          console.log(err);
          this.okayToExit = false;
          let content = err.json();
          if(err.status == 400){
            let msgs = this.GetModelErrors(content);
            this.confirmDialog.confirm("Audit was not created, one or more items need attention. " ,msgs.join("\r\n"),"Validation Error");
          }else if(err.status == 500 && content) {
            this.confirmDialog.confirm("Unexpected error saving audit. ",content,"Error").subscribe();
          }else{
            this.confirmDialog.confirm("Unexpected error saving audit. ","","Error").subscribe();
          }

        } )
    }
  }
  GetModelErrors(errMsg):string[]{
    let msgs:string[]=[];
    if(errMsg){
      if(errMsg.ModelState){
        for(let key in errMsg.ModelState){
          let m1 = errMsg.ModelState[key][0];
          let m2 = errMsg.ModelState[key][1];
          msgs.push( (m1)?((m2)?(m1.length>m2.length?m2:m1):m1):m2 ); //get shorter message-for some reason the array order is not always the same
        }
      }else{
        msgs.push((errMsg.Message)?errMsg.Message:"Unexpected results")
      }
    }
    return msgs;
  }
  canDeactivate(): Observable<boolean> | boolean {
    // Allow synchronous navigation (`true`) if no crisis or the crisis is unchanged
    ;
    if (this.okayToExit == true)
      return true;
    // Otherwise ask the user with the dialog service and return its
    // promise which resolves to true or false when the user decides
    let answerObservable = this.confirmDialog.confirm("Are you sure you wish to cancel editing this audit?"
      , "Any unsaved changes will be lost.", "Confirmation", true);
    return answerObservable;
  //return true;

  }


  getRateAuditData(auditId){
    this.showSpinner = true;
    this.rvrsService.getStandardAuditData( auditId).pipe(
    finalize(() => {
      this.showSpinner = false;
      this.okayToExit = false;
    }))
    .subscribe(data=>{
     this.dataToSave=new CreateReverseAudit();
     this.dataToSave.AmadeusRAC=data.data.AmadeusRAC;
     this.dataToSave.ApolloRAC=data.data.ApolloRAC;
     this.dataToSave.GalileoRAC=data.data.GalileoRAC;
     this.dataToSave.SabreRAC=data.data.SabreRAC;
     this.dataToSave.WorldspanRAC=data.data.WorldspanRAC;
     this.dataToSave.AuditAmadeus=data.data.AuditAmadeus;
     this.dataToSave.AuditApollo=data.data.AuditApollo;
     this.dataToSave.AuditGalileo=data.data.AuditGalileo;
     this.dataToSave.AuditSabre=data.data.AuditSabre;
     this.dataToSave.AuditWorldspan=data.data.AuditWorldspan;
     this.dataToSave.AuditID=data.data.AuditID;
     this.dataToSave.CustomerAccountID=data.data.CustomerAccountID;
     this.dataToSave.CustomerID=data.data.CustomerID;
     this.dataToSave.CustomerAccountName=data.data.CustomerAccountName;
     this.dataToSave.SabrePCC=data.data.SabrePCC;

     this.dataToSave.AuditContactEmailAddress =  this.userProfileService.data.Email;
     this.importedData = data.data;

      this.createStep2.updateData(this.importedData, this.dataToSave);
      this.createStep3.updateData(this.importedData, this.dataToSave);
      });
  }

}
